enum AddressType {
  Home = 'Home',
  Work = 'Work',
  Unspecified = 'Unspecified',
}

export const MapAddressTypeLabel = {
  [AddressType.Home]: 'Home',
  [AddressType.Work]: 'Work',
  [AddressType.Unspecified]: 'Unspecified',
};

export const getAddressTypeAsList = (): CommonList[] => {
  return Object.values(AddressType).map((value) => ({
    id: value,
    label: MapAddressTypeLabel[value],
  }));
};

export default AddressType;
